var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "intercom"
  }, [_c('div', {
    staticClass: "intercomContent"
  }, [_c('div', {
    staticClass: "intrecomLeft"
  }, [_c('div', {
    staticClass: "groupBox"
  }, [_c('span', {
    staticClass: "groupTitle bold"
  }, [_vm._v(_vm._s(_vm.$t('intercom.session')))]), _c('span', {
    staticClass: "grayColor groupNumber"
  }, [_vm._v("(" + _vm._s(_vm.sessionList.length) + ")")])]), _c('div', {
    staticClass: "groupContent"
  }, [_c('div', {
    staticClass: "groupHead"
  }, [_c('ul', [_c('li', {
    staticClass: "w_15"
  }, [_vm._v(_vm._s(_vm.$t('intercom.sessionName')))]), _c('li', {
    staticClass: "w_15"
  }, [_vm._v(_vm._s(_vm.$t('intercom.status')))]), _c('li', {
    staticClass: "w_15"
  }, [_vm._v(_vm._s(_vm.$t('intercom.station')))]), _c('li', {
    staticClass: "w_40"
  }, [_vm._v(_vm._s(_vm.$t('intercom.talent')))]), _c('li', {
    staticClass: "w_10"
  }, [_vm._v(_vm._s(_vm.$t('intercom.talkToSession')))])])]), _c('div', {
    staticClass: "sessionList scrollbar"
  }, [_c('draggable', {
    model: {
      value: _vm.sessionList,
      callback: function ($$v) {
        _vm.sessionList = $$v;
      },
      expression: "sessionList"
    }
  }, _vm._l(_vm.sessionList, function (item) {
    return _c('div', {
      key: item.intercomTabId,
      staticClass: "listLi",
      class: {
        active: _vm.selectSessionInfo.intercomSessionId == item.intercomSessionId
      },
      on: {
        "click": function ($event) {
          return _vm.saveSelectSessionInfo(item);
        }
      }
    }, [_c('span', {
      staticClass: "ellipsis w_15 text-indent-10"
    }, [!item.showRenameInput ? _c('el-popover', {
      attrs: {
        "popper-class": "reName",
        "placement": "top-start",
        "width": "200",
        "trigger": "click"
      }
    }, [_c('span', {
      staticClass: "pointer",
      attrs: {
        "slot": "reference",
        "title": item.sessionName
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "iconfont icon-tuozhuai grayColor m_r_20"
    }), _vm._v(" " + _vm._s(item.sessionName) + " ")]), _c('p', {
      staticStyle: {
        "text-align": "center",
        "cursor": "pointer"
      },
      on: {
        "click": function ($event) {
          return _vm.showRenameInput(item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('intercom.changeSessionName')))])]) : _vm._e(), item.showRenameInput ? _c('el-input', {
      ref: `${item.intercomSessionId}_input`,
      refInFor: true,
      on: {
        "change": val => {
          _vm.saveSessionName(val, item);
        }
      },
      model: {
        value: item.nameInputVal,
        callback: function ($$v) {
          _vm.$set(item, "nameInputVal", $$v);
        },
        expression: "item.nameInputVal"
      }
    }) : _vm._e()], 1), _c('span', {
      staticClass: "listSpan ellipsis w_15 pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.controlActive(item);
        }
      }
    }, [_c('span', {
      staticClass: "activeBox",
      class: {
        active: item.status,
        inActive: !item.status
      }
    }, [item.status ? _c('span', {
      staticClass: "pointerSpan"
    }, [_vm._v("·")]) : _vm._e(), _vm._v(" " + _vm._s(item.status ? _vm.$t('intercom.active') : _vm.$t('intercom.inactive')) + " ")])]), _c('span', {
      staticClass: "ellipsis w_15 center",
      attrs: {
        "title": item.sessionStationsList.length ? _vm.nickNameMap[item.sessionStationsList[0].rtilCode] : ''
      }
    }, [_vm._v(_vm._s(item.sessionStationsList.length ? _vm.nickNameMap[item.sessionStationsList[0].rtilCode] : ''))]), _c('span', {
      staticClass: "ellipsis w_40 text-indent-10 t_left",
      attrs: {
        "title": _vm.returnTalentsName(item)
      }
    }, [_vm._v(_vm._s(_vm.returnTalentsName(item)))]), _c('span', {
      staticClass: "listSpan w_10",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return (() => {}).apply(null, arguments);
        }
      }
    }, [_c('span', {
      staticClass: "talkBtn",
      class: {
        active: item.pushToTalk,
        disabled: item.status != 1
      },
      on: {
        "click": function ($event) {
          return _vm.contrlSessionTalk(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('intercom.talk')) + " "), _c('div'), _c('div')])])]);
  }), 0)], 1)])]), _c('div', {
    staticClass: "intercomRight"
  }, [_c('div', {
    staticClass: "talentModule"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "headerLeft"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('intercom.talent')))]), _c('span', {
    staticClass: "number grayColor"
  }, [_vm._v("(" + _vm._s(_vm.talentList.length) + ")")])]), _c('el-input', {
    staticClass: "headerSearch",
    attrs: {
      "size": "medium",
      "clearable": true,
      "prefix-icon": "el-icon-search",
      "placeholder": _vm.$t('intercom.searchPepole')
    },
    on: {
      "input": _vm.searchTalent,
      "clear": function ($event) {
        return _vm.showAllData('talent');
      }
    },
    model: {
      value: _vm.talentSearch,
      callback: function ($$v) {
        _vm.talentSearch = $$v;
      },
      expression: "talentSearch"
    }
  })], 1), _vm.talentList.length ? _c('div', {
    staticClass: "content"
  }, _vm._l(_vm.talentList, function (item) {
    return _c('div', {
      key: item.rtilCode,
      staticClass: "listItem pointer",
      on: {
        "click": function ($event) {
          return _vm.controlTalent(item);
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "popper-class": "IDTips",
        "trigger": "hover",
        "disabled": _vm.$route.name == 'station'
      }
    }, [_c('nameItem', {
      attrs: {
        "slot": "reference",
        "rtc": _vm.rtc,
        "showOperation": false,
        "sessionList": _vm.sessionList,
        "speakerId": _vm.devicesInfo.speakerId,
        "sessionInfo": _vm.selectSessionInfo,
        "activeSpeakerInfo": _vm.activeSpeakerInfo,
        "nickName": _vm.nickNameMap[item.rtilCode],
        "singChannel": _vm.channels[item.rtilCode],
        "sessionSelect": _vm.returnTalentSelect(item)
      },
      slot: "reference"
    }), _c('div', {
      staticClass: "operationBox",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteSource(item, 'talent');
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      staticStyle: {
        "margin-right": "8px"
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('intercom.removeParticipant')))])])], 1), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }]
    }, [_vm._v(_vm._s(item.rtilCode))])], 1);
  }), 0) : _c('div', {
    staticClass: "nodataBox scrollbar"
  }, [_c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.click')))]), _c('span', {
    staticClass: "greenColor bold"
  }, [_vm._v("\"" + _vm._s(_vm.$t('intercom.copy')) + "\"")]), _c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.buttonInvite')))]), _c('span', {
    staticClass: "whiteColor bold"
  }, [_vm._v(_vm._s(_vm.$t('intercom.partylineApp')))]), _c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.users')))])]), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.click')))]), _vm._m(0), _c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.addPack')))])])])]), _c('el-divider', {
    staticClass: "intercomDivider"
  }), _c('div', {
    staticClass: "stationModule"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "headerLeft"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('intercom.station')))]), _c('span', {
    staticClass: "number grayColor"
  }, [_vm._v("(" + _vm._s(_vm.stationList.length) + ")")])]), _c('el-input', {
    staticClass: "headerSearch",
    attrs: {
      "size": "medium",
      "clearable": true,
      "prefix-icon": "el-icon-search",
      "placeholder": _vm.$t('intercom.searchStation')
    },
    on: {
      "input": _vm.searchStation,
      "clear": function ($event) {
        return _vm.showAllData('station');
      }
    },
    model: {
      value: _vm.stationSearch,
      callback: function ($$v) {
        _vm.stationSearch = $$v;
      },
      expression: "stationSearch"
    }
  })], 1), _c('div', {
    staticClass: "hostBox"
  }, [_c('nameItem', {
    attrs: {
      "rtc": _vm.rtc,
      "showOperation": false,
      "sessionSelect": true,
      "nickName": "DC Bureau (Host)"
    }
  })], 1), _vm.stationList.length ? _c('div', {
    staticClass: "content"
  }, _vm._l(_vm.stationList, function (item) {
    return _c('div', {
      key: item.rtilCode,
      staticClass: "listItem pointer",
      on: {
        "click": function ($event) {
          return _vm.controlStation(item);
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "popper-class": "IDTips",
        "trigger": "hover",
        "disabled": _vm.$route.name == 'station'
      }
    }, [_c('nameItem', {
      attrs: {
        "slot": "reference",
        "rtc": _vm.rtc,
        "index": _vm.returnSelectIndex(item),
        "sessionList": _vm.sessionList,
        "showOperation": false,
        "speakerId": _vm.devicesInfo.speakerId,
        "sessionInfo": _vm.selectSessionInfo,
        "activeSpeakerInfo": _vm.activeSpeakerInfo,
        "nickName": _vm.nickNameMap[item.rtilCode],
        "singChannel": _vm.channels[item.rtilCode],
        "sessionSelect": _vm.returnStationSelect(item, 'session'),
        "createSelect": _vm.returnStationSelect(item, 'create')
      },
      slot: "reference"
    }), _c('div', {
      staticClass: "operationBox",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteSource(item, 'station');
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      staticStyle: {
        "margin-right": "8px"
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t('intercom.removeParticipant')))])])], 1), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }]
    }, [_vm._v("rtilCode:" + _vm._s(item.rtilCode) + " - partyCode:" + _vm._s(_vm.partyInfo.joinCode))])], 1);
  }), 0) : _c('div', {
    staticClass: "nodataBox"
  }, [_c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.click')))]), _vm._m(1), _c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.addReceiver')))])])])])], 1)]), _c('intercomFoot', {
    attrs: {
      "rtc": _vm.rtc,
      "rtcLoaded": _vm.rtcLoaded,
      "mic": _vm.mic,
      "speaker": _vm.speaker,
      "nickName": _vm.nickNameMap[_vm.partyInfo.rtilCode],
      "rtilCode": _vm.partyInfo.rtilCode,
      "devicesInfo": _vm.devicesInfo,
      "microphoneDevice": _vm.devicesInfo.microphoneList,
      "speakerDevice": _vm.devicesInfo.speakerList,
      "selectSessionInfo": _vm.selectSessionInfo
    },
    on: {
      "eventCallback": _vm.footCallback
    }
  }), _vm.State.drawer ? _c('addPackReceiverJoin', {
    attrs: {
      "drawer": _vm.State.drawer,
      "partyCode": _vm.partyInfo.joinCode,
      "userInfo": {
        channelMode: 0
      },
      "channels": _vm.channels
    },
    on: {
      "close": function ($event) {
        _vm.State.drawer = false;
      }
    }
  }) : _vm._e(), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "whiteColor bold"
  }, [_vm._v("\""), _c('i', {
    staticClass: "iconfont icon-addDevice"
  }), _vm._v("\"")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "whiteColor bold"
  }, [_vm._v("\""), _c('i', {
    staticClass: "iconfont icon-addDevice"
  }), _vm._v("\"")]);
}];
export { render, staticRenderFns };